export const weddingPackages = [
  {
    id: 'mclaren-750-wedding',
    vehicle: 'McLaren 750',
    duration: '2 Horas',
    price: 3000,
    includes: 'Luxury car rental + complimentary transfer within Cancun hotel zone',
    description: 'Paquete exclusivo de boda con McLaren 750S. Incluye alquiler del vehículo de lujo y traslado de cortesía dentro de la zona hotelera de Cancún.'
  },
  {
    id: 'lamborghini-huracan-wedding',
    vehicle: 'Lamborghini Huracan Tecnica',
    duration: '2 Horas',
    price: 2800,
    includes: 'Luxury car rental + complimentary transfer within Cancun hotel zone',
    description: 'Paquete exclusivo de boda con Lamborghini Huracán Tecnica. Incluye alquiler del vehículo de lujo y traslado de cortesía dentro de la zona hotelera de Cancún.'
  }
];
